import React, { useContext, useEffect } from 'react'
import { modalContext } from 'global/context/sub-contexts/modalContext'
import SlotMachine from './slots/SlotMachine'
import SlotsOverlay from './slots/SlotsOverlay'
import cherry from 'images/daily-spin/cherry.png'
import diamond from 'images/daily-spin/diamond.png'
import horseshoe from 'images/daily-spin/horseshoe.png'
import logo from 'images/daily-spin/logo.png'
import question from 'images/daily-spin/question.png'

import './SpinModal.scss'

const slotImages = [
  { name: 'default', path: question },
  { name: 'cherry', path: cherry },
  { name: 'diamond', path: diamond },
  { name: 'horseshoe', path: horseshoe },
  { name: 'logo', path: logo },
]

const SpinModal = () => {
  const modal_context = useContext(modalContext)
  const { modalContent, setModalContent, toggleModal } = modal_context || {}
  const closeModal = e => {
    setModalContent(undefined)
    toggleModal(undefined)
  }

  useEffect(() => {
    //Make sure the overlay area is large enough for all of the elements inside it.
    document.querySelector('.slots-area-container').style.minHeight =
      Math.max.apply(null, [
        document.querySelector('.slot-machine').offsetHeight,
        document.querySelector('.slots-overlay-items-container').offsetHeight,
      ]) + 'px'
  })

  const spinForecast = (() => {
    const today = new Date()
    const getWeekday = date => {
      let today = new Date()
      return new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(
        today.setDate(date),
      )
    }
    return [
      { day: 'Tomorrow', spins: modalContent.totalSpinsToday + 1 },
      {
        day: getWeekday(today.getDate() + 2),
        spins: modalContent.totalSpinsToday + 2,
      },
      {
        day: getWeekday(today.getDate() + 3),
        spins: modalContent.totalSpinsToday + 3,
      },
      {
        day: getWeekday(today.getDate() + 4),
        spins: modalContent.totalSpinsToday + 4,
      },
    ]
  })()

  return (
    <>
      {modal_context && (
        <>
          <div className="modal-spin">
            <button
              className="modal-close"
              onClick={closeModal}
              aria-label="Next"
            ></button>
            <div className="modal-header">
              <span className="modal-header-spin">{modalContent.title}</span>
            </div>
            <div className="content-body">
              <div className="latest-winner">
                <p>
                  Our latest 40,000pts winner was {modalContent.lastWinner} on{' '}
                  {modalContent.lastWinDate}
                </p>
              </div>
              <div className="slots-area-container">
                <SlotsOverlay slotImages={slotImages} />

                <SlotMachine slotImages={slotImages} />
              </div>

              <p>Match symbols in order shown to win the points.</p>
              <img
                className="legend"
                src={`${process.env.SITE_ASSET_URL}/dailyspinmodal-noasterisk.png`}
                alt=""
              />
              <div className="spin-day-container">
                <ul>
                  {spinForecast.map(forecast => {
                    return (
                      <li key={forecast.day}>
                        <span className="day">{forecast.day}</span>
                        <span className="spins">
                          {forecast.spins > 5 ? 5 : forecast.spins} Spins
                        </span>
                      </li>
                    )
                  })}
                </ul>
                <p>Earn 5 spins every day once you’ve logged in for 5+ days.</p>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default SpinModal
